import { api } from "api";

export const getGuide = (recPerPage, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(`/api/guide/get/${recPerPage}`)
      .then((res) => {
        dispatch({
          type: "GET_GUIDE_SUCCESS",
          payload: res.data,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_GUIDE_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};
